import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import locale from './locale';

import './index.css';

createApp(App).use(router).use(locale).mount('#app');
